<template>
  <div>
    <Head :title="`${uid}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        Edit: {{ uid }} |
        <Link class="text-orange-400 hover:text-orange-600" href="/manufacturing-receipts"> Manufacturing Receipts</Link>
      </h1>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.quantity" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Original Quantity" />
          <text-input v-model="form.adjusted_quantity" :error="form.errors.adjusted_quantity" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Adjusted Quantity" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Update</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    item: Object,
    uid: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        id: this.item.id,
        quantity: this.item.quantity,
        adjusted_quantity: this.item.adjusted_quantity,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/manufacturing-receipts/${this.item.id}`)
    },
  },
}
</script>
